import type { JSX } from 'react'

export function TypingIndicator({ actors }: { actors: Array<{ key: string; name: string }> }): JSX.Element | null {
  if (actors.length === 0) return null
  const names = actors.map((a) => a.name)
  const label = names.length === 1 ? `${names[0]} is typing` : `${names.join(' and ')} are typing`
  return (
    <div className="flex items-center gap-2 px-4 py-1 text-[11px] text-gray-500" aria-live="polite">
      <span className="flex gap-0.5" aria-hidden="true">
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.3s]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.15s]" />
        <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400" />
      </span>
      {label}…
    </div>
  )
}
